// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialogContent .item[data-v-0dd6265a]{line-height:2.08333vw}.dialogContent .item label[data-v-0dd6265a]{width:50%;display:inline-block;text-align:right}.dialogContent .maintenance[data-v-0dd6265a]{display:flex}", ""]);
// Exports
module.exports = exports;
